module.exports = __webpack_public_path__ + "img/jht-icon-13.5b712df6.png";